import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cece1422"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-footer" }
const _hoisted_2 = { class: "half-size-btn-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "small-text" }, "（初月含む）", -1))

import { reactive } from "vue";
import Btn from "@/components/common/Btn.vue";
import ChangeOperatorModal from "../common/ChangeOperatorModal.vue";
import IrregularUpdateModal from "../common/IrregularUpdateModal.vue";
import { ICompanyInvoice } from "@/models/company-invoice";
import CompanyInvoiceApi from "@/api/company-invoice";

interface IProps {
  companyInvoice: ICompanyInvoice;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CardFooter',
  props: {
    companyInvoice: {}
  },
  setup(__props: any) {

const props = __props;



const state = reactive({
  visibleOperatorModal: false,
  visibleIrregularModal: false,
});

const closeOperatorModal = () => {
  state.visibleOperatorModal = false;
};

const openOperatorModal = () => {
  closeIrregularModal();
  state.visibleOperatorModal = true;
};

const closeIrregularModal = () => {
  state.visibleIrregularModal = false;
};

const openIrregularModal = () => {
  closeOperatorModal();
  state.visibleIrregularModal = true;
};

const onClickChangeOperator = () => {
  console.log("onClickChangeOperator");
  openOperatorModal();
};

const onClickIrregularChangeOperator = () => {
  console.log("onClickIrregularChangeOperator");
  openIrregularModal();
};

const onClickOrderInvoice = async () => {
  await CompanyInvoiceApi.updateCompanyInvoiceStatusToBilled(
    props.companyInvoice.id
  ).then(() => {
    // reload する
    location.reload();
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Btn, {
          class: "sp-btn",
          text: "取引担当者を変更",
          "on-click-event": onClickChangeOperator,
          "btn-type": "btn-gray"
        }),
        _createVNode(Btn, {
          class: "sp-btn",
          "btn-type": "btn-gray",
          "on-click-event": onClickIrregularChangeOperator
        }, {
          default: _withCtx(() => [
            _createTextVNode(" イレギュラーのため変更 "),
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(Btn, {
          class: "sp-btn full-width",
          text: "この内容で請求書を発行依頼",
          "on-click-event": onClickOrderInvoice
        })
      ])
    ]),
    _createVNode(ChangeOperatorModal, {
      visible: state.visibleOperatorModal,
      "company-invoice": _ctx.companyInvoice,
      "on-close": closeOperatorModal
    }, null, 8, ["visible", "company-invoice"]),
    _createVNode(IrregularUpdateModal, {
      visible: state.visibleIrregularModal,
      "company-invoice": _ctx.companyInvoice,
      "on-close": closeIrregularModal
    }, null, 8, ["visible", "company-invoice"])
  ], 64))
}
}

})